import { EWrApiAction, EWrExportType, IExagoSessionRequest } from 'src/app/feature-modules/exago/models/exago.models';
import { environment } from 'src/environments/environment';

export const exagoSessionBaseConfig: IExagoSessionRequest = {
  Page: 'ExagoHome',
  ExportType: EWrExportType.Html,
  ShowErrorDetail: environment.reporting_show_error_detail,
};

export const reportSessionConfig: IExagoSessionRequest = {
  ...exagoSessionBaseConfig,
  ShowTabs: false,
};

export const builderSessionConfig: IExagoSessionRequest = {
  ...exagoSessionBaseConfig,
  ApiAction: EWrApiAction.Home,
  ShowTabs: true,
};
